<template>
  <footer id="core-footer" class="esign-footer">
    <div class="esign-footer__inner">
      <div class="esign-footer__brand">
        <img src="../../assets/bsre.png" alt="Logo BSrE" width="112" height="auto">
        <span class="esign-footer__divider" aria-hidden="true"></span>
        <span class="esign-footer__app">
          <strong>e-Sign Universitas Indonesia</strong>
          <span>Penandatanganan dokumen elektronik</span>
        </span>
      </div>
      <span class="copyright">
        Copyright &copy; {{ (new Date()).getFullYear() }} Universitas Indonesia. All rights reserved.
      </span>
    </div>
  </footer>
</template>

<script>
  export default {
    data: () => ({
      links: [
        { name: 'Home', Link: '/#' },
        { name: 'Creative Tim', Link: 'https://www.creative-tim.com' },
        { name: 'About Us', Link: 'https://creative-tim.com/presentation' },
        { name: 'Blog', Link: 'https://blog.creative-tim.com' }
      ]
    })
  }
</script>

<style>
#core-footer {
  z-index: 0;
}

.esign-footer {
  flex-shrink: 0;
  border-top: 1px solid var(--esign-border);
  background: var(--esign-surface);
}

.esign-footer__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 24px;
  max-width: none;
  margin: 0 auto;
  padding: 16px 24px calc(16px + env(safe-area-inset-bottom, 0px));
}

.esign-footer__brand {
  display: flex;
  align-items: center;
  gap: 16px;
}

.esign-footer__divider {
  width: 1px;
  height: 32px;
  background: var(--esign-border);
}

.esign-footer__app {
  display: flex;
  flex-direction: column;
  line-height: 1.35;
  font-size: 12px;
  color: var(--esign-text-muted);
}

.esign-footer__app strong {
  font-size: 13px;
  color: var(--esign-text);
}

.esign-footer .copyright {
  font-size: 12px;
  color: var(--esign-text-muted);
}

@media (max-width: 600px) {
  .esign-footer__inner {
    padding: 16px 12px calc(16px + env(safe-area-inset-bottom, 0px));
  }

  .esign-footer__divider,
  .esign-footer__app {
    display: none;
  }
}
</style>
